export const CLEAR_PARTNER_COOKIES = 'clear-partner-cookies';
const clearPartnerCookies = () => ({ type: CLEAR_PARTNER_COOKIES });
export default clearPartnerCookies;
